import create from "zustand";
export var resetToolbarTutorialStore = function () {
    useToolbarTutorialStore.setState({
        showTutorial: true,
        isTutorialCompleted: false,
        currentStep: 0,
    });
};
export var useToolbarTutorialStore = create(function (set) { return ({
    showTutorial: true,
    isTutorialCompleted: false,
    currentStep: 0,
    setShowTutorial: function (showTutorial) {
        return set(function () { return ({
            showTutorial: showTutorial,
        }); });
    },
    setTutorialCompleted: function (isTutorialCompleted) {
        return set(function () { return ({
            isTutorialCompleted: isTutorialCompleted,
        }); });
    },
    setCurrentStep: function (currentStep) {
        return set(function () { return ({
            currentStep: currentStep,
        }); });
    },
}); });
